import { Facebook, Instagram, LinkedIn, TikTok, Twitter, WhatsApp, YouTube } from 'blaze-ui/icons'
import { DesignChannel } from 'components/NewFileModal/Types'
import { MultiStepSchema } from './Types'
import { FlowA2Schema } from './Desktop/FlowA'
import { FlowBSchema } from './Desktop/FlowB'
import { FlowCSchema } from './Desktop/FlowC'

type DesignChannelSchemas = Partial<{ [key in DesignChannel]: MultiStepSchema<DesignChannel> }>

export const flowA2Schemas: DesignChannelSchemas = {
  [DesignChannel.InstagramStory]: {
    ...FlowA2Schema({ generationType: DesignChannel.InstagramStory }),
    meta: {
      type: DesignChannel.InstagramStory,
      channel: DesignChannel.InstagramStory,
      title: 'Instagram Story',
      icon: Instagram,
      previewUrl: '',
      isVideo: true,
    },
  },
}

export const flowBSchemas: DesignChannelSchemas = {
  [DesignChannel.TwitterProfilePicture]: {
    ...FlowBSchema,
    meta: {
      type: DesignChannel.TwitterProfilePicture,
      channel: DesignChannel.TwitterProfilePicture,
      title: 'X/Twitter Profile Image',
      icon: Twitter,
      previewUrl: '',
    },
  },
  [DesignChannel.TwitterCoverImage]: {
    ...FlowBSchema,
    meta: {
      type: DesignChannel.TwitterCoverImage,
      channel: DesignChannel.TwitterCoverImage,
      title: 'X/Twitter Cover Image',
      icon: Twitter,
      previewUrl: '',
    },
  },
  [DesignChannel.FacebookCover]: {
    ...FlowBSchema,
    meta: {
      type: DesignChannel.FacebookCover,
      channel: DesignChannel.FacebookCover,
      title: 'Facebook Cover Image',
      icon: Facebook,
      previewUrl: '',
    },
  },
  [DesignChannel.FacebookProfilePicture]: {
    ...FlowBSchema,
    meta: {
      type: DesignChannel.FacebookProfilePicture,
      channel: DesignChannel.FacebookProfilePicture,
      title: 'Facebook Profile Picture',
      icon: Facebook,
      previewUrl: '',
    },
  },
  [DesignChannel.LinkedInProfilePicture]: {
    ...FlowBSchema,
    meta: {
      type: DesignChannel.LinkedInProfilePicture,
      channel: DesignChannel.LinkedInProfilePicture,
      title: 'LinkedIn Profile Picture',
      icon: LinkedIn,
      previewUrl: '',
    },
  },
  [DesignChannel.LinkedInBanner]: {
    ...FlowBSchema,
    meta: {
      type: DesignChannel.LinkedInBanner,
      channel: DesignChannel.LinkedInBanner,
      title: 'LinkedIn Banner',
      icon: LinkedIn,
      previewUrl: '',
    },
  },
  [DesignChannel.WhatsAppSticker]: {
    ...FlowBSchema,
    meta: {
      type: DesignChannel.WhatsAppSticker,
      channel: DesignChannel.WhatsAppSticker,
      title: 'Whatsapp Sticker',
      icon: WhatsApp,
      previewUrl: '',
    },
  },
  [DesignChannel.TikTokThumbnail]: {
    ...FlowBSchema,
    meta: {
      type: DesignChannel.TikTokThumbnail,
      channel: DesignChannel.TikTokThumbnail,
      title: 'TikTok Thumbnail',
      icon: TikTok,
      previewUrl: '',
    },
  },
  [DesignChannel.YoutubeChannelArt]: {
    ...FlowBSchema,
    meta: {
      type: DesignChannel.YoutubeChannelArt,
      channel: DesignChannel.YoutubeChannelArt,
      title: 'Youtube Channel Art',
      icon: YouTube,
      previewUrl: '',
    },
  },
  [DesignChannel.YoutubeProfilePicture]: {
    ...FlowBSchema,
    meta: {
      type: DesignChannel.YoutubeProfilePicture,
      channel: DesignChannel.YoutubeProfilePicture,
      title: 'Youtube Profile Picture',
      icon: YouTube,
      previewUrl: '',
    },
  },
}

export const flowCSchemas: DesignChannelSchemas = {
  [DesignChannel.InstagramPost]: {
    ...FlowCSchema({ generationType: DesignChannel.InstagramPost }),
    meta: {
      type: DesignChannel.InstagramPost,
      channel: DesignChannel.InstagramPost,
      title: 'Instagram Post',
      icon: Instagram,
      previewUrl: '',
      aspectRatios: {
        portrait: 'instagram-portrait-post',
        landscape: 'instagram-landscape-post',
        square: 'instagram-square-post',
      },
      captionTypes: {
        post: 'Post',
        story: 'Story',
        reel: 'Reel',
      },
    },
  },
  [DesignChannel.LinkedInPost]: {
    ...FlowCSchema({ generationType: DesignChannel.LinkedInPost }),
    meta: {
      type: DesignChannel.LinkedInPost,
      channel: DesignChannel.LinkedInPost,
      title: 'LinkedIn Post',
      icon: LinkedIn,
      previewUrl: '',
      aspectRatios: {
        portrait: 'linkedin-portrait-post',
        landscape: 'linkedin-post',
      },
    },
  },
  [DesignChannel.FacebookPost]: {
    ...FlowCSchema({ generationType: DesignChannel.FacebookPost }),
    meta: {
      type: DesignChannel.FacebookPost,
      channel: DesignChannel.FacebookPost,
      title: 'Facebook Post',
      icon: Facebook,
      previewUrl: '',
      aspectRatios: {
        portrait: 'facebook-portrait-post',
        landscape: 'facebook-post',
      },
    },
  },
  [DesignChannel.TwitterPost]: {
    ...FlowCSchema({ generationType: DesignChannel.TwitterPost }),
    meta: {
      type: DesignChannel.TwitterPost,
      channel: DesignChannel.TwitterPost,
      title: 'X/Twitter Post',
      icon: Twitter,
      previewUrl: '',
      aspectRatios: {
        portrait: 'twitter-portrait-post',
        landscape: 'twitter-post',
      },
    },
  },
}

export const desktopDesignSchemas = { ...flowA2Schemas, ...flowBSchemas, ...flowCSchemas }
